// import { SortableContainer, SortableHandle } from 'react-sortable-hoc';

import React from 'react';
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import {
  SortableContext,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import {
  restrictToVerticalAxis,
  restrictToParentElement,
} from '@dnd-kit/modifiers';

import OriginLeafContainer from './treeLeaf/container';

// Replacement for SortableHandle using @dnd-kit
export const DragHandle = ({ listeners, attributes }) => (
  <div
    className="lifecycle-drag-handle"
    {...listeners}
    {...attributes}
    style={{ cursor: 'grab' }}
  >
    <span className="appkiticon icon-menu-outline" />
  </div>
);

const DraggableLeafContainer = (props) => {
  const { containerId, onSortEnd, items = [], ...restProps } = props;

  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 20,
      },
    }),
    useSensor(KeyboardSensor),
  );

  const handleDragEnd = (event) => {
    const { active, over } = event;

    if (active.id !== over?.id && onSortEnd) {
      // Extract indices from the IDs (assuming format like "item-0", "item-1", etc.)
      const oldIndex =
        typeof active.id === 'string' && active.id.includes('-')
          ? parseInt(active.id.split('-')[1])
          : parseInt(active.id);
      const newIndex =
        typeof over.id === 'string' && over.id.includes('-')
          ? parseInt(over.id.split('-')[1])
          : parseInt(over.id);

      if (!isNaN(oldIndex) && !isNaN(newIndex)) {
        onSortEnd({ oldIndex, newIndex });
      }
    }
  };

  // Create items array for SortableContext
  // This assumes the items prop contains an array of items to be sorted
  const sortableItems = items.map((_, index) => `item-${index}`);

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragEnd={handleDragEnd}
      modifiers={[restrictToVerticalAxis, restrictToParentElement]}
    >
      <SortableContext
        items={sortableItems}
        strategy={verticalListSortingStrategy}
      >
        <OriginLeafContainer {...restProps} items={items} />
      </SortableContext>
    </DndContext>
  );
};

export default DraggableLeafContainer;
